import React from "react";
import "./Loader.css";
export default function Loader(props) {
  const { progress } = props;
  return progress ? <div className="loading">Loading&#8230;</div> : "";
}
